import React from 'react';
import PropTypes from 'prop-types';
import NavPage from 'components/layout/NavPage';
import './Landing.scss';

const Landing = ({
  AA_Prelogin_Hero_Headline,
  AA_Prelogin_Hero_Body,
  AA_Prelogin_CTA_Sign_in,
  AA_Prelogin_CTA_Join_for_free,
  AA_Prelogin_Subhero_Headline,
  AA_Prelogin_Subhero_Body,
  AA_Prelogin_Subhero_Body_2,
  AA_Prelogin_Block1_Title,
  AA_Prelogin_Block1_Headline,
  AA_Prelogin_Block1_Body,
  AA_Prelogin_Block2_Title,
  AA_Prelogin_Block2_Headline,
  AA_Prelogin_Block2_Body,
  AA_Prelogin_Block3_Title,
  AA_Prelogin_Block3_Headline,
  AA_Prelogin_Block3_Body,
  AA_Prelogin_Block4_Title,
  AA_Prelogin_Block4_Headline,
  AA_Prelogin_Block4_Body,
  AA_Prelogin_Final_Note,
}) => (
  <NavPage renderWhiteBackground>
    <div className="home-dashboard-hero-container">
      <h1 className="home-dashboard-primary-heading">{AA_Prelogin_Hero_Headline}</h1>
      <div className="dashboard-color-block" />
      <br />
      <br />
      <p className="dashboard-paragraph">{AA_Prelogin_Hero_Body}</p>
      <div className="home-dashboard-hero-button-container">
        <a href="/home" className="home-dashboard-button-primary">{AA_Prelogin_CTA_Join_for_free}</a>
        <a href="/home" className="home-dashboard-button-secondary">{AA_Prelogin_CTA_Sign_in}</a>
      </div>
    </div>

    <div className="dashboard-page-container">
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h3 className="home-dashboard-secondary-heading">{AA_Prelogin_Subhero_Headline}</h3>
        <p className="dashboard-paragraph">{AA_Prelogin_Subhero_Body}</p>
        <p className="dashboard-paragraph">{AA_Prelogin_Subhero_Body_2}</p>
      </div>

      <div className="dashboard-flex-row">
        <div className="dashboard-flex-item dashboard-image">
          <img className="dashboard-image" src={require('../assets/meet_the_author@2x.jpg')} />
        </div>
        <div className="dashboard-flex-item">
          <h4 className="home-dashboard-tertiary-heading">{AA_Prelogin_Block1_Title.toUpperCase()}</h4>
          <div className="dashboard-color-block" />
          <h3 className="home-dashboard-secondary-heading">{AA_Prelogin_Block1_Headline}</h3>
          <p className="dashboard-paragraph">{AA_Prelogin_Block1_Body}</p>
        </div>
      </div>

      <div className="dashboard-flex-row row-reverse">
        <div className="dashboard-flex-item dashboard-image">
          <img src={require('../assets/global_reach@2x.jpg')} />
        </div>
        <div className="dashboard-flex-item right-aligned">
          <h4 className="home-dashboard-tertiary-heading">{AA_Prelogin_Block2_Title.toUpperCase()}</h4>
          <div className="dashboard-color-block" />
          <h3 className="home-dashboard-secondary-heading">{AA_Prelogin_Block2_Headline}</h3>
          <p className="dashboard-paragraph">{AA_Prelogin_Block2_Body}</p>
        </div>
      </div>

      <div className="dashboard-flex-row">
        <div className="dashboard-flex-item dashboard-image">
          <img src={require('../assets/books@2x.jpg')} />
        </div>
        <div className="dashboard-flex-item">
          <h4 className="home-dashboard-tertiary-heading">{AA_Prelogin_Block3_Title.toUpperCase()}</h4>
          <div className="dashboard-color-block" />
          <h3 className="home-dashboard-secondary-heading">{AA_Prelogin_Block3_Headline}</h3>
          <p className="dashboard-paragraph">{AA_Prelogin_Block3_Body}</p>
        </div>
      </div>

      <div className="dashboard-flex-row row-reverse">
        <div className="dashboard-flex-item dashboard-image">
          <img src={require('../assets/insights@2x.jpg')} />
        </div>
        <div className="dashboard-flex-item right-aligned">
          <h4 className="home-dashboard-tertiary-heading">{AA_Prelogin_Block4_Title.toUpperCase()}</h4>
          <div className="dashboard-color-block" />
          <h3 className="home-dashboard-secondary-heading">{AA_Prelogin_Block4_Headline}</h3>
          <p className="dashboard-paragraph">{AA_Prelogin_Block4_Body}</p>
        </div>
      </div>

      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <span className="dashboard-paragraph dashboard-final-note">{AA_Prelogin_Final_Note}</span>
        <a href="/home" className="home-dashboard-button-primary">{AA_Prelogin_CTA_Join_for_free}</a>
        <a href="/home" className="home-dashboard-button-secondary">{AA_Prelogin_CTA_Sign_in}</a>
      </div>
    </div>
  </NavPage>
);

Landing.propTypes = {
  AA_Prelogin_Hero_Headline: PropTypes.string.isRequired,
  AA_Prelogin_Hero_Body: PropTypes.string.isRequired,
  AA_Prelogin_CTA_Sign_in: PropTypes.string.isRequired,
  AA_Prelogin_CTA_Join_for_free: PropTypes.string.isRequired,
  AA_Prelogin_Subhero_Headline: PropTypes.string.isRequired,
  AA_Prelogin_Subhero_Body: PropTypes.string.isRequired,
  AA_Prelogin_Subhero_Body_2: PropTypes.string.isRequired,
  AA_Prelogin_Block1_Title: PropTypes.string.isRequired,
  AA_Prelogin_Block1_Headline: PropTypes.string.isRequired,
  AA_Prelogin_Block1_Body: PropTypes.string.isRequired,
  AA_Prelogin_Block2_Title: PropTypes.string.isRequired,
  AA_Prelogin_Block2_Headline: PropTypes.string.isRequired,
  AA_Prelogin_Block2_Body: PropTypes.string.isRequired,
  AA_Prelogin_Block3_Title: PropTypes.string.isRequired,
  AA_Prelogin_Block3_Headline: PropTypes.string.isRequired,
  AA_Prelogin_Block3_Body: PropTypes.string.isRequired,
  AA_Prelogin_Block4_Title: PropTypes.string.isRequired,
  AA_Prelogin_Block4_Headline: PropTypes.string.isRequired,
  AA_Prelogin_Block4_Body: PropTypes.string.isRequired,
  AA_Prelogin_Final_Note: PropTypes.string.isRequired,
};

export default Landing;
